/*jshint esversion: 6 */
import QueryParams from "./utils/query-params";
import ajax from "./utils/ajax";
import config from "./utils/config";
import ua from "./utils/ua-parser";

var PageNameMapForLogging = {
  "/": "Cash Marketing: Home",
  "/security": "Cash Marketing: Security",
};

export default class EventStream {
  constructor() {
    this.ua = new ua();
  }

  hasOptedIntoStatisticsTracking() {
    return config.getRegionConfig().hasOptedIntoStatisticsTracking;
  }

  // Gets the referrer as a Location object
  getReferrer() {
    if (document.referrer) {
      var parser = document.createElement("a");
      parser.href = document.referrer;
      return parser;
    }
    return {};
  }

  // Find the nearest parent node with a class name.
  // (we don't use IDs).
  getNearestParentIdentifier(element) {
    element = element && element.parentNode;
    while (element && !element.className) {
      element = element.parentNode;
    }
    return element && element.className;
  }

  pageClick(action, targetElement) {
    // Don't log the element if it's the body
    targetElement =
      targetElement && targetElement !== document.body ? targetElement : {};
    var text =
      targetElement &&
      ((targetElement.getAttribute &&
        targetElement.getAttribute("data-link-label")) ||
        targetElement.textContent);

    this.logEvent("page_click", {
      page_click_description: "", // Eventstream breaks up page_click events by description. We want them all grouped together.
      page_click_action: action,

      element_parent_identifier: this.getNearestParentIdentifier(targetElement),
      element_identifier: targetElement.className,
      element_text: (text && text.trim()) || null,
      element_type:
        (targetElement.tagName && targetElement.tagName.toUpperCase()) || null,
      element_title: targetElement.title,
    });
  }

  pageView(pageName) {
    let queryParams = QueryParams();
    return this.logEvent("page_view", {
      webpage_title: pageName || document.title,
      webpage_utm_source: queryParams.utm_source,
      webpage_utm_medium: queryParams.utm_medium,
      webpage_utm_campaign: queryParams.utm_campaign,
      webpage_utm_term: queryParams.utm_term,
    });
  }

  event(actionName, params) {
    params = params || {};
    var paramsToLog = {};
    paramsToLog.cash_web_event_action = actionName;
    paramsToLog.cash_web_event_description = params.cash_web_event_description;
    paramsToLog.cash_web_event_category = params.cash_web_event_category;
    paramsToLog.cash_web_event_detail = params.cash_web_event_detail;
    paramsToLog.cash_web_event_amount = params.cash_web_event_amount;
    this.logEvent("cash_web_event", paramsToLog);
  }

  appDownload(storeSentTo) {
    var isAndroid = this.ua.isAndroid;
    this.event("DOWNLOAD_APP", {
      cash_web_event_category: storeSentTo || (isAndroid ? "ANDROID" : "IOS"),
    });
  }

  logEvent(catalogName, params) {
    if (catalogName && this.hasOptedIntoStatisticsTracking()) {
      return ajax({
        url: "/event/eventstream2",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: this.normalizeData(catalogName, params),
        withCredentials: true,
      });
    } else return;
  }

  // Similar to $.extend({}, obj1, obj2)
  extendObject(result) {
    result = result || {};
    for (var i = 1; i < arguments.length; i++) {
      var obj = arguments[i];
      if (!obj) {
        continue;
      }

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          result[key] = obj[key];
        }
      }
    }
    return result;
  }

  compactObject(object) {
    var key,
      value,
      clone = {};
    for (key in object) {
      if (object.hasOwnProperty(key)) {
        value = object[key];
        if (value !== null && value !== undefined) {
          clone[key] = value;
        }
      }
    }
    return clone;
  }

  normalizeData(catalogName, params) {
    params = params || {};
    var location = window.location;
    var referrer = this.getReferrer();

    params = this.extendObject({}, params, {
      catalog_name: catalogName,

      // Browser
      browser_height: window.innerHeight,
      browser_width: window.innerWidth,
      browser_major_version: this.ua.browser.major,
      browser_name: this.ua.browser.name,
      browser_version: this.ua.browser.version,

      // Device
      device_build_device: this.ua.device.model,
      device_density_dpi: this.ua.devicePixelRatio || 1,
      device_form_factor: this.ua.device.type,
      device_manufacturer: this.ua.device.vendor,
      device_model: this.ua.device.model,
      device_screen_height: window.screen.height,
      device_screen_width: window.screen.width,

      // OS
      os_name: this.ua.os.name,
      os_version: this.ua.os.version,

      // Web Page
      webpage_base_url: location.hostname + location.pathname,
      webpage_full_url: location.href,
      webpage_path: location.pathname,
      webpage_referrer: referrer.href,
      webpage_referrer_host: referrer.hostname,
      webpage_referrer_path: referrer.pathname,
      webpage_title: params.webpage_title || document.title,
    });

    return JSON.stringify(this.compactObject(params));
  }
}
